import { render, staticRenderFns } from "./accreditDialog.vue?vue&type=template&id=ed7f3748&scoped=true"
import script from "./accreditDialog.vue?vue&type=script&lang=js"
export * from "./accreditDialog.vue?vue&type=script&lang=js"
import style0 from "./accreditDialog.vue?vue&type=style&index=0&id=ed7f3748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7f3748",
  null
  
)

export default component.exports